import React, { Component } from "react";

import FormComponent from "dataphi-react-components/dist/Containers/FormScreen/FormComponent";
import Source from "./Source";

import StudentProfile from "../../../StudentProfileContainer/Component/StudentProfile";

const formMetaDataList = [
  "med_height",
  "med_weight",
  "med_bp_sys",
  "med_bp_dia",
  "med_heart_rate",
  "med_body_temp",
  "med_respiratory_rate",
];
const minMaxValidations = [
  "med_bp_sys",
  "med_bp_dia",
  "med_heart_rate",
  "med_respiratory_rate",
];

const vitalMetaMap = {
  med_bp_sys: 4,
  med_bp_dia: 5,
  med_respiratory_rate: 6,
  med_heart_rate: 7,
};

const formMetaDataSerial = {
  ...Source.formDefs.metaData.reduce(
    (accumulator, field, index) =>
      formMetaDataList.includes(field.name)
        ? { ...accumulator, [field.name]: index }
        : { ...accumulator },
    {},
  ),
};

class EpisodeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialFetch: true,
      initialVaidations: true,
    };
  }

  componentWillMount() {
    this.props.clearForm();
    this.props.initializeForm({});
  }

  componentWillReceiveProps(newProps) {}

  handelSubmit = (data) => {
    console.log("data", JSON.stringify(data, null, 2));

    let episode = Object.assign({}, data);

    episode.med_episode_id = new Date().getTime();
    episode.med_created = new Date();
    episode.med_modified = new Date();
    episode.med_complaint = episode?.med_complaint?.value;
    episode.med_called_parents =
      episode.med_called && episode.med_called.includes("parent") ? true : null;
    episode.med_called_ambulance =
      episode.med_called && episode.med_called.includes("ambulance")
        ? true
        : null;

    delete episode.med_called;

    this.props.postEpisode(episode, 1);
    this.props.closeEpisodeForm();
  };

  handelBlur = (input) => {
    let x = input;
  };

  getMinMaxForAge = (meta, type, age) => {
    let mm;
    meta &&
      meta.forEach((element) => {
        if (element.category === type) {
          if (
            element.metadata &&
            element.metadata.age_min <= age &&
            element.metadata.age_max >= age
          ) {
            mm = {
              min: element.metadata.value_min,
              max: element.metadata.value_max,
            };
          }
        }
      });

    return mm || {};
  };

  addVitalValidations = () => {
    this.setState({ initialVaidations: false });
    let viltas = this.props.metaData?.metaVitals;
    let age = this.props.age;
    minMaxValidations.forEach((element) => {
      let mm = this.getMinMaxForAge(viltas, vitalMetaMap[element], age);
      Source.formDefs.metaData[formMetaDataSerial[element]].validation.push(
        Source.minValue(mm.min),
      );
      Source.formDefs.metaData[formMetaDataSerial[element]].validation.push(
        Source.maxValue(mm.max),
      );
    });
  };

  render() {
    this.state.initialVaidations && this.addVitalValidations();
    return (
      <div className="row">
        <FormComponent
          formDefs={Source.formDefs}
          onSubmit={(data) => this.handelSubmit(data)}
          onClose={() => this.props.toggleModal(false)}
          onFieldBlur={(input) => this.handelBlur(input)}
        />
      </div>
    );
  }
}

export default EpisodeForm;
